import ExlyFeedbacks from "./pages/UserFeedbacks/ExlyFeedbacks";

export default ExlyFeedbacks;